<section class="container-fluid min-height-container py-5 bg-gray-300">
    <div class="container">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <h1 class="text-center display-3 mb-5" id="faq">F.A.Q.'s</h1>
                <div class="row">
                    @for (question of faqs; track question) {
                    <div class="col-md-6 my-2">
                        <div class="flip-card box-shadow">
                            <div class="flip-card-inner">
                                <div class="flip-card-front bg-gray-600 text-white border border-gray-900">
                                    <p class="p-3 fs-2 fw-bold position-absolute text-center translate-middle top-50 start-50 w-100">
                                        {{question.q}}
                                    </p>
                                </div>
                                <div class="flip-card-back bg-white">
                                    <p class="p-3 fs-4 position-absolute text-center translate-middle top-50 start-50 w-100" [innerHTML]="question.a">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</section>